import { http } from '@/api/client/httpClient';
import type {
  EmailSettingsDto,
  NameValue,
  SendTestEmailInput,
  TimeZoneSettingsDto,
  UpdateEmailSettingsDto,
} from '@/api/types/settingManagement';

// Routes from the ABP SettingManagement HttpApi controllers (9.1):
//   TimeZoneSettingsController ("api/setting-management/timezone")
//     GetAsync          -> GET  /api/setting-management/timezone
//     UpdateAsync(input)-> POST /api/setting-management/timezone
//     GetTimezonesAsync -> GET  /api/setting-management/timezone/timezones
//   EmailSettingsController ("api/setting-management/emailing")
//     GetAsync          -> GET  /api/setting-management/emailing
//     UpdateAsync(input)-> POST /api/setting-management/emailing
//     SendTestEmailAsync-> POST /api/setting-management/emailing/send-test-email
const TIMEZONE_BASE = '/api/setting-management/timezone';
const EMAILING_BASE = '/api/setting-management/emailing';

export const settingManagementApi = {
  async getTimeZone(): Promise<TimeZoneSettingsDto> {
    const { data } = await http.get<TimeZoneSettingsDto>(TIMEZONE_BASE);
    return data;
  },

  async getTimezones(): Promise<NameValue[]> {
    const { data } = await http.get<NameValue[]>(`${TIMEZONE_BASE}/timezones`);
    return data;
  },

  async updateTimeZone(input: TimeZoneSettingsDto): Promise<void> {
    await http.post(TIMEZONE_BASE, input);
  },

  async getEmailSettings(): Promise<EmailSettingsDto> {
    const { data } = await http.get<EmailSettingsDto>(EMAILING_BASE);
    return data;
  },

  async updateEmailSettings(input: UpdateEmailSettingsDto): Promise<void> {
    await http.post(EMAILING_BASE, input);
  },

  async sendTestEmail(input: SendTestEmailInput): Promise<void> {
    await http.post(`${EMAILING_BASE}/send-test-email`, input);
  },
};
